import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConnectPathIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3 3h18v18H3z",
			opacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			strokeWidth: 2.5,
			d: "M5 19 19 5"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 5,
			cy: 19,
			r: 2,
			fill: "currentColor",
			stroke: "none"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 19,
			cy: 5,
			r: 2,
			fill: "currentColor",
			stroke: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m3 3 2 16M19 5l2 16",
			opacity: .2
		})
	]
});
export default SvgConnectPathIcon;
